import { render, staticRenderFns } from "./crm-edit-dropdown.vue?vue&type=template&id=7a8b9795&"
import script from "./crm-edit-dropdown.vue?vue&type=script&lang=js&"
export * from "./crm-edit-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports